












































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import LanguagesBtns from "@/components/app/shared/btn&dd/languages-btns.vue";
import BSwitch from "@/components/app/shared/switchs/b-switch.vue";
import UploadingImageToServer from "@/components/app/images/uploading-image-to-server.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import type { ComplexMenuSheet } from "@/@types/menu/complex-menu";
import type { Locale, LanguageCode } from "@/@types/_shared/locale";
import type { SICON } from "@/@types/_shared/src";

@Component({
  components: {
    StandartModal,
    LanguagesBtns,
    BSwitch,
    UploadingImageToServer,
  },
  mixins: [validationMixin],
  validations: {
    name: { required },
  },
})
class ComplexMenuEditModal extends Vue {
  @Prop({ type: Object, default: null }) item!: ComplexMenuSheet | null;
  @Prop({ type: String, default: "menu/complex" }) folder!: string;

  defaultLocale: LanguageCode = this.$store.getters.getLanguages
    ? this.$store.getters.getLanguages[0]
    : "ru";
  currentLocale: LanguageCode = this.defaultLocale;

  iconLibs = ["bi", "material", "fa", "filoxenia", ""];

  show = true;
  name = "";
  names: Locale = {};
  title = "";
  titles: Locale = {};
  description = "";
  descriptions: Locale = {};
  uptime = "";
  icon = "";
  iconLib = "";
  image = "";
  background = "";
  poster = "";

  @Watch("currentLocale")
  changeLocale(): void {
    this.name = this.names[this.currentLocale] || "";
    this.title = this.titles[this.currentLocale] || "";
    this.description = this.descriptions[this.currentLocale] || "";
  }

  @Watch("name")
  changeName(): void {
    this.$set(this.names, this.currentLocale, this.name);
  }

  @Watch("title")
  changeTitle(): void {
    this.$set(this.titles, this.currentLocale, this.title);
  }

  @Watch("description")
  changeDescription(): void {
    this.$set(this.descriptions, this.currentLocale, this.description);
  }

  @Watch("item")
  autoFillingForm(): void {
    if (!this.item) return;
    this.names = { ...this.item.name };
    this.titles = this.item.title ? { ...this.item.title } : {};
    this.descriptions = this.item.description
      ? { ...this.item.description }
      : {};
    this.uptime = this.item.uptime || "";
    this.show = this.item.show;
    this.icon =
      this.item.src && this.item.src.icon ? this.item.src.icon.icon : "";
    this.iconLib =
      this.item.src && this.item.src.icon ? this.item.src.icon.lib : "";
    this.image = this.item.src ? this.item.src.image || "" : "";
    this.background = this.item.src ? this.item.src.background || "" : "";
    this.poster = this.item.src ? this.item.src.poster || "" : "";
    this.changeLocale();
  }

  onSubmit(e: Event): void {
    e.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }

    const data: Partial<ComplexMenuSheet> = {
      name: this.names,
      title: this.titles,
      description: this.descriptions,
      uptime: this.uptime,
      show: this.show,
      src: {
        icon: {
          icon: this.icon,
          lib: this.iconLib as SICON["lib"],
        },
        image: this.image,
        background: this.background,
        poster: this.poster,
      },
    };

    this.$emit("save", data);
    this.$bvModal.hide("complex-menu-edit");
  }

  isClean(): void {
    this.names = {};
    this.titles = {};
    this.descriptions = {};
    this.name = "";
    this.title = "";
    this.description = "";
    this.uptime = "";
    this.show = true;
    this.icon = "";
    this.iconLib = "";
    this.image = "";
    this.background = "";
    this.poster = "";
    this.currentLocale = this.defaultLocale;
    this.$v.$reset();
  }
}
export default ComplexMenuEditModal;
